/*
 * whino-carousel-loop.js
 * Carrusel de "Colección destacada" (Dawn) INFINITO y fluido:
 *  - Bucle continuo sin saltos (clona las diapositivas: [A][originales][C]).
 *  - Scroll libre con INERCIA (deslizamiento tipo "gotas de Dios").
 *  - Flechas que avanzan suave y nunca se quedan sin fin.
 * Solo afecta a slider-component dentro de .collection.
 */
(function () {
  'use strict';
  if (window.__whinoLoopInit) return;
  window.__whinoLoopInit = true;

  function now() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

  function cleanClone(node) {
    node.setAttribute('data-whino-clone', '1');
    node.removeAttribute('id');
    var ids = node.querySelectorAll('[id]');
    for (var i = 0; i < ids.length; i++) ids[i].removeAttribute('id');
  }

  function enhance(sc) {
    if (sc.__whinoLoop) return;
    var slider = sc.querySelector('[id^="Slider-"]');
    if (!slider) return;
    var originals = Array.prototype.filter.call(slider.children, function (n) { return n.nodeType === 1; });
    if (originals.length < 2) return;
    sc.__whinoLoop = true;

    // Scroll libre y fluido
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';
    slider.style.cursor = 'grab';
    slider.style.webkitOverflowScrolling = 'touch';

    // Clonado para bucle infinito: [clonesAntes][originales][clonesDespues]
    var fragBefore = document.createDocumentFragment();
    var fragAfter = document.createDocumentFragment();
    var firstAfter = null;
    originals.forEach(function (s, i) {
      var c1 = s.cloneNode(true); cleanClone(c1); fragAfter.appendChild(c1); if (i === 0) firstAfter = c1;
      var c2 = s.cloneNode(true); cleanClone(c2); fragBefore.appendChild(c2);
    });
    slider.appendChild(fragAfter);
    slider.insertBefore(fragBefore, originals[0]);

    var base = 0, setW = 0;
    function measure() {
      base = originals[0].offsetLeft;
      setW = firstAfter.offsetLeft - originals[0].offsetLeft;
    }
    measure();
    if (setW <= 0) { sc.__whinoLoop = false; return; }
    slider.scrollLeft = base;

    // Reposición sin salto visible (los 3 bloques son idénticos)
    var fixing = false;
    function normalize() {
      if (setW <= 0 || fixing) return;
      if (slider.scrollLeft >= base + setW) { fixing = true; slider.scrollLeft -= setW; fixing = false; }
      else if (slider.scrollLeft < base) { fixing = true; slider.scrollLeft += setW; fixing = false; }
    }
    slider.addEventListener('scroll', normalize, { passive: true });

    window.addEventListener('resize', function () {
      var off = slider.scrollLeft - base;
      measure();
      if (setW > 0) slider.scrollLeft = base + ((off % setW) + setW) % setW;
    });

    // Flechas: avanzan ~1 producto, suave (el bucle lo gestiona normalize)
    var prev = sc.querySelector('button[name="previous"]');
    var next = sc.querySelector('button[name="next"]');
    function step() {
      var a = originals[0], b = originals[1];
      return b ? (b.offsetLeft - a.offsetLeft) : a.getBoundingClientRect().width;
    }
    if (prev && next) {
      var keep = function () { prev.removeAttribute('disabled'); next.removeAttribute('disabled'); };
      var mo = new MutationObserver(keep);
      mo.observe(prev, { attributes: true, attributeFilter: ['disabled'] });
      mo.observe(next, { attributes: true, attributeFilter: ['disabled'] });
      keep();
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); slider.scrollBy({ left: step(), behavior: 'smooth' }); }, true);
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); slider.scrollBy({ left: -step(), behavior: 'smooth' }); }, true);
    }

    // Arrastre con inercia
    var isDown = false, startX = 0, startScroll = 0, moved = false, lastX = 0, lastT = 0, vel = 0, raf = null;
    function stopM() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      stopM(); isDown = true; moved = false;
      startX = e.pageX; startScroll = slider.scrollLeft; lastX = e.pageX; lastT = now(); vel = 0;
      slider.style.cursor = 'grabbing';
    });
    slider.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 6) moved = true;
      slider.scrollLeft = startScroll - dx;
      var t = now(), dt = t - lastT;
      if (dt > 0) vel = (e.pageX - lastX) / dt;
      lastX = e.pageX; lastT = t;
    });
    function end() {
      if (!isDown) return;
      isDown = false; slider.style.cursor = 'grab';
      var v = vel * 16;
      function momentum() {
        if (Math.abs(v) < 0.25) { raf = null; return; }
        slider.scrollLeft -= v;
        v *= 0.95;
        raf = requestAnimationFrame(momentum);
      }
      if (Math.abs(v) > 0.25) raf = requestAnimationFrame(momentum);
      setTimeout(function () { moved = false; }, 0);
    }
    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointerleave', end);
    slider.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() {
    var list = document.querySelectorAll('.collection slider-component');
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
